
// import lib
import validHelper from '../lib/validHelper';
// import isEmpty from '../lib/isEmpty';

export const changePasswordValid = (reqBody) => {
    let validDoc = {
        currentPassword: { type: 'string', required: true, },
        newPassword: { type: 'string', required: true, min: 6, max: 16 },
        confirmPassword: { type: 'string', required: true, isEqual: reqBody?.newPassword },
    };
    return validHelper(validDoc, reqBody)
}

export const createManualUserValid = (reqBody) => {
    let validDoc = {
        userName: { type: 'string', required: true, min: 3, max: 16 },
        email: { type: 'string', required: true, regex: 'email' },
        phone: { type: 'number', required: true, length: 10 },
        password: { type: 'string', required: true, min: 6, max: 16 }
    }
    return validHelper(validDoc, reqBody)
}

export const editUserValid = (reqBody) => {
    let validDoc = {
        userId: { type: 'string', required: true },
        userName: { type: 'string', required: true, min: 3, max: 16 },
        email: { type: 'string', required: true, regex: 'email' },
        phone: { type: 'number', required: true, length: 10 },
        password: { type: 'string', required: true, min: 6, max: 16 }
    }
    return validHelper(validDoc, reqBody)
}

export const bankDetailsValid = (reqBody) => {
    let validDoc = {
        paymentType: { type: 'string', required: true, enum: ['bank', 'upi'] },
        accountHolderName: { type: 'string', required: true, min: 3, max: 22 },
        bankName: { type: 'string', required: true, min: 4, max: 16 },
        branchName: { type: 'string', required: true, min: 4, max: 16 },
        ifscCode: { type: 'string', required: true, regex: 'ifsc' },
        accountNumber: { type: 'number', required: true, regex: 'bank_acc' },
    };
    return validHelper(validDoc, reqBody)
}

export const upiDetailsValid = (reqBody) => {
    let validDoc = {
        paymentType: { type: 'string', required: true, enum: ['bank', 'upi'] },
        upiProvider: { type: 'string', required: true, enum: ['GPay', 'PhonePe'] },
        upiUsername: { type: 'string', required: true, min: 3, max: 22 },
        upiNumber: { type: 'number', required: true, length: 10 }
    };
    return validHelper(validDoc, reqBody)
}